//@ts-check
import React, { Component } from 'react'
import { observer } from "mobx-react";
import IconsContainer from "Utils/IconsContainer";

/**
 * @typedef {object} props
 * @property {string} className
 * @property {boolean} checked
 * @property {(checked: boolean) => void} [onChange]
 * @extends {Component<props>}
 */
class Checkbox extends Component {
    render() {
        return (
            <div className={`checkbox ${this.props.checked ? ' checked' : ''} ${this.props.className}`}
                onClick={_ => {
                    if (this.props.onChange)
                        this.props.onChange(!this.props.checked);
                }}>
                <div className="checkbox-not-checked-icon">
                    {IconsContainer.Get('ca-checkbox-off')}
                </div>
                <div className="checkbox-checked-icon">
                    {IconsContainer.Get('ca-checkbox-on')}
                </div>
            </div>
        )
    }
};

export default observer(Checkbox);